import React from 'react';

import { type MessageDescriptor, useIntl } from 'react-intl-next';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Pressable, type PressableProps, Text, type XCSS, xcss } from '@atlaskit/primitives';
import { N0 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';

type ClearFilterOptionsButtonProps = {
	text?: MessageDescriptor;
	xcss?: XCSS;
} & PressableProps;

const ClearFilterButton = ({
	text = messages.clearFilterButtonLabel,
	xcss,
	...props
}: ClearFilterOptionsButtonProps) => {
	const { formatMessage } = useIntl();
	return (
		<Pressable {...props} xcss={[clearFilterOptionsButtonStyles, xcss]}>
			<Text>{formatMessage(text)}</Text>
		</Pressable>
	);
};

export default ClearFilterButton;

const clearFilterOptionsButtonStyles = xcss({
	background: token('color.background.input', N0),
	color: 'color.text.subtle',
	border: 'none',
	paddingLeft: 'space.250',
	font: 'inherit',
	cursor: 'pointer',
	outline: 'inherit',
	display: 'flex',
	justifyContent: 'flex-start',
	alignItems: 'center',
	height: '36px',
	width: '100%',

	':hover': {
		backgroundColor: 'color.background.input.hovered',
	},

	':disabled': {
		color: 'color.text.accent.gray',
		cursor: 'default',
	},
});
